// Work & Keep brand assets. Supplied logos are used as-is (never recolored/redrawn).
// - BrandLogo: full horizontal logo — for light backgrounds / primary branded areas.
// - BrandMark: circular W&K mark — for compact placements.
// On dark backgrounds, use BrandWordmark (Playfair display text) for contrast.

export function BrandLogo({ className = "h-9 w-auto" }) {
  return <img src="/brand/wk-logo.png" alt="Work & Keep" className={className} data-testid="brand-logo" />;
}

export function BrandMark({ className = "h-9 w-9" }) {
  return <img src="/brand/wk-mark.png" alt="Work & Keep" className={className} data-testid="brand-mark" />;
}

export function BrandWordmark({ className = "text-xl" }) {
  return (
    <span className={`font-heading ${className}`} data-testid="brand-wordmark">
      Work &amp; Keep
    </span>
  );
}
